module.exports = __webpack_public_path__ + "static/media/multiple-stops.8a3f41f8.svg";